import {
    SSEEventType,
    SSEEventData,
} from '../types/sseEvents';

/**
 * Parses SSE event data from a JSON string.
 * Uses type assertions - trusts the backend to send valid data.
 * 
 * @param eventType - The type of SSE event
 * @param rawData - The raw JSON string from the SSE stream
 * @returns The parsed SSE event data
 */
export function parseSSEEventData(eventType: SSEEventType, rawData: string): SSEEventData {
    // Handle non-JSON events (like 'done')
    if (eventType === 'done') {
        return rawData as string;
    }

    // Handle JSON events (like 'thinking', 'answer', 'metadata', 'error')
    try {
        const parsed = JSON.parse(rawData);
        return parsed as SSEEventData;
    } catch (error) {
        throw new Error(`Failed to parse JSON event data for event type: ${eventType}`);
    }
}